module.exports = __webpack_public_path__ + "img/publishimg.7b7c513.png";